module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/db426166326d7895a3b09f3ac8040616.png";